import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import controller from "./controller.vue";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import noImg from "@/assets/noimg.png";
export default {
  i18n: require('../design_i18n'),
  name: "nested-draggable",
  components: {
    // ...components,
    // ...m_components,
    controller: controller,
    draggable: draggable
  },
  data: function data() {
    return {
      // platform: 0
      noImg: noImg
    };
  },
  computed: _objectSpread({}, mapState({
    components: function components(state) {
      return state.design.components;
    },
    list: function list(state) {
      /* let arr =
      state.design.components.filter(item => {
      return /Notice|Navbar|Menubar|Footer/.test(item.name) == false
      })
      return arr */
      return state.design.components;
    },
    mainList: function mainList(state) {
      // let curPlateform = localStorage.platform == 'pc' ? 1 : 2

      return state.design.components.filter(function (item) {
        // return /Notice|Navbar|Menubar|Footer/.test(item.name) == false && item.componentValue.location.includes(curPlateform);
        // return /Notice|Navbar|Menubar|Footer/.test(item.name) == false
        return typeof item.draggable === 'undefined';
      });
    },
    headerList: function headerList(state) {
      var arr = state.design.components.filter(function (item) {
        return /Notice|Navbar|Menubar/.test(item.name) == true && item.componentValue.status == true;
      });
      return arr;
    },
    footerList: function footerList(state) {
      var arr = state.design.components.filter(function (item) {
        return /Footer/.test(item.name) == true && item.componentValue.status == true;
      });
      return arr;
    },
    filterList: function filterList(state) {
      var noDragList = state.design.componentTemplates.filter(function (item) {
        if (item.draggable == false) {
          return item.name;
        }
      });
      return noDragList.map(function (item) {
        return item.name;
      });
    },
    platform: function platform(state) {
      return state.design.platform;
    }
  })),
  methods: {
    handleClone: function handleClone(e) {},
    handleEnd: function handleEnd(e) {
      // e oldIndex  newIndex
      // mainList 1 2   / 2 1

      // a 0
      // b 1
      // c 2 c

      // 真正的组件列表 这个列表应该与没有拖动之前的列表一样
      var realList = this.$store.state.design.components.filter(function (item) {
        // return /Notice|Navbar|Menubar|Footer/.test(item.name) == false && item.componentValue.location.includes(curPlateform);
        // return /Notice|Navbar|Menubar|Footer/.test(item.name) == false
        return typeof item.draggable === 'undefined';
      });

      // 从真正的组件列表找出位于newIndex的组件

      var com = realList[e.newIndex];

      // 从真正的组件列表找到位于oldIndex的要拖动的组件
      var oldCom = realList[e.oldIndex];

      // 从所有的组件列表中找到oldCom的位置
      var oldIndex = this.$store.state.design.components.indexOf(oldCom);

      // 然后删除这个组件
      this.$store.state.design.components.splice(oldIndex, 1);

      // 然后在所有的组件列表中找到这个组件的位置

      var index = this.$store.state.design.components.indexOf(com);

      // 在所有的组件列表根据index插入组件
      // 判断方向
      if (e.newIndex - e.oldIndex > 0) {
        this.$store.state.design.components.splice(index + 1, 0, oldCom);
      } else {
        this.$store.state.design.components.splice(index, 0, oldCom);
      }

      // let newc = this.mainList[e.oldIndex]  // 要插入位置的组件
      // // let newi = this.components.indexOf(newc) // 要插入的位置
      //
      // let oldc = this.mainList[e.newIndex]
      // if(newc.id === oldc.id) return
      // let com_deleted_index = this.components.indexOf(oldc)
      // console.log('AAAA mainList', this.mainList)
      // //
      // let del_c = this.$store.state.design.components.splice(com_deleted_index,1)[0]
      //
      // let com_insert_index = this.components.indexOf(newc) // 要插入的位置
      //
      //   let del = this.$store.state.design.components.splice(com_insert_index, 0, oldc)

      // let arr = [oldc, newc]
      // let del = this.$store.state.design.components.splice(newi,2, ...arr)

      // console.log('AAA del', del)
      // let d_c = this.$store.design.components.splice(i,1)
    },
    setDragImg: function setDragImg(dataTransfer) {
      // let img = new Image()
      // img.src = 'https://www.google.no/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png'
      // 因为我们用了scale缩放 导致拖动时产生的效果 有点问题 这里给一个空的元素
      var dom = document.createElement("span");
      dataTransfer.setDragImage(dom, 0, 0);
    },
    onMove: function onMove(e) {
      var _this = this;
      var draggable = e.relatedContext.element.draggable;
      if (typeof draggable === "undefined") {
        return true;
      }
      if (draggable === false) {
        if (this.closeTip) return false;
        this.closeTip = this.$message.error(this.$t('com.noDragHere')).then(function () {
          _this.closeTip = null;
        });
        return false;
      }
      return true;
    },
    /**
     * 拖拽结束事件变更
     */
    handle_drag_change: function handle_drag_change(data) {
      /**
      draggable 拖动是按照dom节点索引添加的
      在放下的时候就在:list中按照dom索引添加了一个对象
      所以在@change完成后 要先删除添加的对象
      在现在项目中头部有3个固定不动的组件
      所以在insertComponent函数中要给index加3 (先删除自动添加的对象 然后再+3的位置添加我们的组件)
       */

      // 新增组件模式
      if (data.hasOwnProperty("added")) {
        /* console.log('data', data) */
        /* 判断位置可不可以添加 */
        /* let newIndex = data.added.newIndex
        let c = this.list[newIndex + 1]
        if(c && typeof c.draggable == 'boolean' && c.draggable === false){
        this.$store.state.design.components.splice(newIndex, 1)
        this.$message.error('不允许在这个位置添加')
        return
        } */
        /* console.log(
        *   "newIndex",
        *   data.added.newIndex,
        *   data.added.newDraggableIndex
        * ); */
        /*
         * 	let c = this.components(data.added.newIndex)
         * 	if(c.name == 'Footer'){
         * 	  this.components.splice(data.added.newIndex - 1, 1)
         *
         * 	} */

        this.$store.dispatch("design/add_page_component", {
          name: data.added.element.name,
          title: data.added.element.title,
          componentPack: data.added.element.componentPack,
          order: data.added.element.order,
          maxNum: data.added.element.maxNum,
          newIndex: data.added.newIndex,
          draggable: data.added.element.draggable,
          platform: data.added.element.platform,
          type: data.added.element.type,
          // location: data.added.element.location,
          // index: a,
          index: data.added.element.order
        });
      }
    }
  },
  filters: {
    // 功能数据
    dataFormate: function dataFormate(conponent) {
      // 如果有配置项的话
      if (conponent.is_loaded_config && conponent.hasOwnProperty("config")) {
        var datas = {};
        Object.keys(conponent.config.datas).map(function (key) {
          datas[key] = conponent.config.datas[key].value;
        });
        return datas;
      } else {
        return conponent.remote_data || {};
      }
    },
    // 样式数据
    styleFormate: function styleFormate(conponent) {
      // 如果有配置项的话
      if (conponent.is_loaded_config && conponent.hasOwnProperty("config")) {
        var styles = {};
        Object.keys(conponent.config.styles).map(function (key) {
          styles[key] = conponent.config.styles[key].value;
        });
        return styles;
      } else {
        return conponent.remote_style || {};
      }
    }
  }
};